import TreeStore from 'stores/TreeStore';
import EtsngNode from 'models/EtsngNode';

const NAMESPACE = 'etsng';

export default class EtsngTreeStore extends TreeStore {

  nodes = this.collection({
    model: EtsngNode
  })

  foundNodes = this.collection({
    model: EtsngNode
  })

  async fetchChildNodes(parentNode) {
    return await super.fetchChildNodes(parentNode, NAMESPACE);
  }

  async fetchParents(parentNode) {
    return await super.fetchParents(parentNode, NAMESPACE);
  }

  async search(term) {
    return await super.search(term, NAMESPACE);
  }

  toString() {
    return NAMESPACE;
  }

}



// WEBPACK FOOTER //
// ./src/stores/EtsngTreeStore.js